import {
  DownOutlined,
  FilePdfOutlined,
  FileWordOutlined,
} from '@ant-design/icons'
import { Button, Dropdown, Menu } from 'antd'
import PropTypes from 'prop-types'

import { createUseStyles } from 'react-jss'
import DownloadLink from './DownloadLink'

const useStyles = createUseStyles({
  icon: {
    marginRight: 10,
  },
})

export default function DownloadButtons({ resource }) {
  const classes = useStyles()
  const { filePath, rawFilePath, mergedFilePath } = resource
  const { deviceReport, biobridgeReport, mergedReport } = resource

  const biobridgeReportLink = biobridgeReport || filePath
  const deviceReportLink = deviceReport || rawFilePath
  const mergedReportLink = mergedFilePath || mergedReport

  const downloadLinks =
    biobridgeReportLink || deviceReportLink || mergedReportLink

  if (!downloadLinks) return null

  return (
    <Dropdown
      overlay={
        <Menu>
          {biobridgeReportLink && (
            <Menu.Item key="1">
              <DownloadLink path={biobridgeReportLink}>
                <FilePdfOutlined className={classes.icon} />
                <span>Report PDF</span>
              </DownloadLink>
            </Menu.Item>
          )}
          {deviceReportLink && (
            <Menu.Item key="2">
              <DownloadLink path={deviceReportLink}>
                <FileWordOutlined className={classes.icon} />
                <span>Transmission PDF</span>
              </DownloadLink>
            </Menu.Item>
          )}
          {mergedReportLink && (
            <Menu.Item key="2">
              <DownloadLink path={mergedReportLink}>
                <FileWordOutlined className={classes.icon} />
                <span>Merged PDF</span>
              </DownloadLink>
            </Menu.Item>
          )}
        </Menu>
      }
    >
      <Button>
        Download <DownOutlined />
      </Button>
    </Dropdown>
  )
}

DownloadButtons.propTypes = {
  resource: PropTypes.shape({
    editableFilePath: PropTypes.string,
    filePath: PropTypes.string,
    rawFilePath: PropTypes.string,
    mergedFilePath: PropTypes.string,
    deviceReportPath: PropTypes.string,
    deviceReport: PropTypes.string,
    biobridgeReport: PropTypes.string,
    mergedReport: PropTypes.string,
  }).isRequired,
}
